export default class NumberUtil {
  // 변수가 number type 인지 판단
  static isNumber(value: unknown): value is number {
    return typeof value === 'number' && !isNaN(value);
  }

  static isDecimal(value: number | string): boolean {
    if (typeof value === 'string') {
      value = Number(value);
    }

    return Number.isFinite(value) && !Number.isInteger(value);
  }

  static convertToFraction(value: string | number): { integerPart: string; decimalPart: string } {
    if (typeof value === 'number') {
      value = value.toString();
    }

    const [integerPart = '', decimalPart = ''] = value.toString().split('.');

    return {
      integerPart,
      decimalPart,
    };
  }

  //최댓값도 포함, 최솟값도 포함하는 정수 난수  count 갯수 만큼 반환 (중복 X)
  static getRandomIntInclusiveByCount(minValue: number, maxValue: number, count: number): number[] {
    const result: number[] = [];
    const min = Math.ceil(minValue);
    const max = Math.floor(maxValue);

    while (result.length < count) {
      const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;

      if (!result.includes(randomNum)) {
        result.push(randomNum);
      }
    }

    return result;
  }
}
